/**
 * Collapsible Tabs (Accordion) Component - Sleek Theme OS 2.0
 */
if (!customElements.get('collapsible-tabs')) {
  class CollapsibleTabs extends HTMLElement {
    constructor() {
      super();
      this.detailsElements = [];
    }

    connectedCallback() {
      this.detailsElements = Array.from(this.querySelectorAll('.accordion-details'));
      this.allowMultiple = this.hasAttribute('data-allow-multiple');

      this.detailsElements.forEach((details) => {
        details.addEventListener('toggle', (e) => {
          if (details.open && !this.allowMultiple) {
            this.closeOthers(details);
          }
        });
      });
    }

    closeOthers(activeDetails) {
      this.detailsElements.forEach((details) => {
        if (details !== activeDetails && details.open) {
          details.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('collapsible-tabs', CollapsibleTabs);
}
